module.exports = __webpack_public_path__ + "static/media/adjuge-en.23bc1c06.png";